import React from 'react';
import './TeamHome.css';
import TeamHome from './TeamHome';


function TeamSection({heading}) {
  return (
     <div className='team-home' style={{backgroundColor:'white'}}> 
        <div className='team-home-content'>
          <h2 style={{marginBottom:'-30px', color:'black'}}>{heading}</h2> 
        </div>
        <TeamHome/> 
        


    </div>
    
  )
}

export default TeamSection